import * as React from "react";

import { EventRecord } from "./EventRecord";
import { formatNanoTimestamp } from "./EventsTableColumns";
import styles from "./EventsTableColumns.module.css";

function formatDetailValue(key: string, value: unknown): React.ReactNode {
  if (value === null || value === undefined) {
    return <span className={styles.detailEmpty}>—</span>;
  }
  if (key === "start_time" || key === "end_time") {
    return formatNanoTimestamp(value as bigint);
  }
  if (typeof value === "bigint") {
    return value.toString();
  }
  if (typeof value === "string") {
    if (value === "") {
      return <span className={styles.detailEmpty}>—</span>;
    }
    return value;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  if (Array.isArray(value) && value.length === 0) {
    return <span className={styles.detailEmpty}>—</span>;
  }
  if (
    typeof value === "object" &&
    value !== null &&
    !Array.isArray(value) &&
    Object.keys(value).length === 0
  ) {
    return <span className={styles.detailEmpty}>—</span>;
  }
  return (
    <pre className={styles.detailJson}>
      {JSON.stringify(
        value,
        (_, v: unknown) => (typeof v === "bigint" ? v.toString() : v),
        2,
      )}
    </pre>
  );
}

export function EventDetailFields({ event }: { event: EventRecord }) {
  const entries = Object.entries(event);
  return (
    <div
      className={styles.detailFields}
      role="region"
      aria-label={`Details for event ${event.event_id}`}
    >
      {entries.map(([key, value]) => (
        <div key={key} className={styles.detailField}>
          <div className={styles.detailKey}>{key}</div>
          <div className={styles.detailValue}>
            {formatDetailValue(key, value)}
          </div>
        </div>
      ))}
    </div>
  );
}
